module.exports = __webpack_public_path__ + "static/media/da.868f242f.png";